import React from 'react';
import {
  Button, Typography, Dialog, DialogContent, Icon, IconButton,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import customizationLogo from '../../assets/img/customization_logo.svg';
import Dropdown from './Dropdown';
import { resourceFormStyle } from '../../css/style';
import { itemCustomizationFields } from '../../data/Constants';
import * as utilFunctions from '../../utils/Functions';
import ToolTip from './ToolTip';
const styles = resourceFormStyle();

const ItemCustomization = ({
  fieldData,
  onOpenAndCloseDialog,
  isDialogOpen,
  dropDownData,
  onChangeDialogDropDownOption,
  onClickAddButton,
  itemCustomizationData,
  actions,
  loading,
  resources,
  apiToken,
  itemId,
  getFieldType,
  onChangeFieldData,
  hidepadding,
  onDeleteItemCustomization,
  dialogHidden,
  width,
}) => {
  const dropdownOptions = resources && resources.customizations && resources.customizations.sort((a, b) => a.position - b.position);
  const isMobile = utilFunctions.isDeviceView('sm', width);
  const itemCustomizationTitle = isMobile ? 'itemCustomizationTitleMobile' : 'itemCustomizationTitle';
  const itemCustomizationsFieldText = isMobile ? 'itemCustomizationsFieldTextMobile' : 'itemCustomizationsFieldText';
  return (
    <div style={styles.itemCustomizationContainer}>
      {!dialogHidden && (
        <div style={styles.itemCustomizationTitleContainer}>
          <Typography style={styles.customizationTitle}>MODIFIER GROUPS: </Typography>
          <Typography
            style={styles.addCusTextLink}
            color="primary"
            onClick={() => onOpenAndCloseDialog(itemId)}
          >
            add modifier group
        </Typography>
        </div>
      )}
      {!dialogHidden && (
        <Dialog
          maxWidth="md"
          open={isDialogOpen}
          onClose={() => onOpenAndCloseDialog()}
        >
          <DialogContent style={styles.addItemCusDialogContainer}>
            <IconButton
              style={styles.itemCusDialogCloseBtn}
              onClick={() => onOpenAndCloseDialog()}
            >
              <Icon>close</Icon>
            </IconButton>
            <img src={customizationLogo} style={{ marginTop: '50px' }} />
            <Typography style={styles.itemCusDialogTitle}>ADD MODIFIER GROUP</Typography>
            <Dropdown
              data={dropDownData}
              actions={actions}
              dropdownOptions={dropdownOptions}
              dropdownType={fieldData.dataTable}
              loading={loading}
              allowMultiple
              apiToken={apiToken}
              style={styles.customizationDropdownStyle}
              onChange={event => onChangeDialogDropDownOption(event, resources.customizations, true)}
            />
            <Button
              style={styles.itemCusBtnInDialog}
              onClick={() => onClickAddButton()}
            >
              ADD
              </Button>
            <Typography
              style={styles.itemCusDialogCancelText}
              onClick={() => onOpenAndCloseDialog()}
            >
              cancel
            </Typography>
          </DialogContent>
        </Dialog>
      )}
      {itemCustomizationData && itemCustomizationData.map(customization => (
        <div
          key={customization.id}
          style={styles.itemCustomizationsContainer}
        >
          <Typography style={styles[itemCustomizationTitle]}>{customization.name}</Typography>
          {
            itemCustomizationFields.map((field) => {
              const FieldType = getFieldType(field.type);
              let paddingVal = (field.type === 'boolean') ? hidepadding : undefined;
              const isFree = utilFunctions.isDeviceView('md', width) && field.title === 'Free';
              paddingVal = field.title === 'Mandatory' ? true : hidepadding;

              return (
                <div
                  key={field.key}
                  style={isFree ? styles.itemCustomizationsFreeField : styles.itemCustomizationsField}
                >
                  <Typography style={styles[itemCustomizationsFieldText]}>{`${field.title}:`}</Typography>
                  <FieldType
                    value={customization[field.key]}
                    data={customization[field.key]}
                    style={styles.customizationTextFieldStyle}
                    inputProps={{ style: { textAlign: 'center' } }}
                    InputProps={{ disableUnderline: true }}
                    disabled={field.disabled}
                    hidepadding={paddingVal}
                    fieldTitle={field.title}
                    width={width}
                    onChange={event => onChangeFieldData(event, fieldData, customization, field, itemId)}
                  />
                  {
                    (field.title === 'Free')
                    && (
                      <ToolTip resources={resources} field={field} />
                    )
                  }
                </div>
              );
            })
          }
          <IconButton style={styles.iconButton} onClick={() => onDeleteItemCustomization(fieldData, customization, itemId)}>
            <Icon>close</Icon>
          </IconButton>
        </div>
      ))}
    </div>
  );
};

ItemCustomization.propTypes = {
  fieldData: PropTypes.object,
  onOpenAndCloseDialog: PropTypes.func,
  isDialogOpen: PropTypes.bool.isRequired,
  dropDownData: PropTypes.array,
  onChangeDialogDropDownOption: PropTypes.func,
  onClickAddButton: PropTypes.func,
  itemCustomizationData: PropTypes.array,
  actions: PropTypes.objectOf(PropTypes.func),
  loading: PropTypes.bool,
  resources: PropTypes.object,
  apiToken: PropTypes.string,
  getFieldType: PropTypes.func,
  onChangeFieldData: PropTypes.func,
  onDeleteItemCustomization: PropTypes.func,
};

export default ItemCustomization;
